import { styled } from '@mui/system'
import { colors } from '../../../../../../Components/consts'

type ListProps = {
  open: boolean
}

export const HiddenContainer = styled('div')<ListProps>(({ open }) => ({
  display: open ? 'block' : 'none',
  padding: 0,
}))

export const SubList = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'absolute',
  zIndex: 1,
  width: 200,
  background: colors.lightestGrey,
  border: `1px solid ${colors.lightGrey}`,
  borderRadius: '0 0 5px 5px',
  marginTop: -4,
  [theme.breakpoints.down('sm')]: {
    width: 100,
  },
  [theme.breakpoints.down('xs')]: {
    width: 75,
  },
  '& .dropdown': {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& li': {
      margin: theme.spacing(1, 0),
      padding: theme.spacing(1.25, 2),
      borderBottom: `1px solid ${colors.lightGrey}`,
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(1, 0),
        padding: theme.spacing(0.75, 1),
      },
    },
  },
  '& a': {
    textDecoration: 'none',
    fontWeight: 500,
    fontSize: '1.2rem',
    color: colors.black,
    [theme.breakpoints.down('sm')]: {
      fontWeight: 500,
      fontSize: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontWeight: 500,
      fontSize: '0.9rem',
    },
  },
}))

export const BlueBtn = styled('button')(({ theme }) => ({
  display: 'inline-block',
  padding: theme.spacing(2, 2),
  borderRadius: 25,
  border: 'none',
  fontSize: '1.2rem',
  fontWeight: 'bold',
  color: colors.white,
  minWidth: 120,
  background: `linear-gradient(to bottom right, ${colors.darkBlue}, ${colors.lightBlue})`,
  cursor: 'pointer',
  '&:hover': {
    background: `linear-gradient(to bottom right, ${colors.lightBlue}, ${colors.darkBlue})`,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '1rem',
    padding: theme.spacing(2, 3),
    minWidth: 120,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
    padding: theme.spacing(2, 3),
    minWidth: 40,
  },
}))

export const Presale = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  cursor: 'pointer',
}))
